import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();

  const [isHome, setIsHome] = useState(false);
  const [isHelp, setIsHelp] = useState(false);
  const [isInviteUser, setIsInviteUser] = useState(false);
  const [isDemoData, setIsDemoData] = useState(false);
  const [isContactUs, setIsContactUs] = useState(false);
  const [isUpdates, setIsUpdates] = useState(false);
  const [isSettings, setIsSettings] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Home");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    // Reset all menu states when current state changes
    if (iscurrentState !== "Home") {
      setIsHome(false);
    }
    if (iscurrentState !== "Help") {
      setIsHelp(false);
    }
    if (iscurrentState !== "InviteUser") {
      setIsInviteUser(false);
    }
    if (iscurrentState !== "DemoData") {
      setIsDemoData(false);
    }
    if (iscurrentState !== "ContactUs") {
      setIsContactUs(false);
    }
    if (iscurrentState !== "Updates") {
      setIsUpdates(false);
    }
    if (iscurrentState !== "Settings") {
      setIsSettings(false);
    }
  }, [
    history,
    iscurrentState,
    isHome,
    isHelp,
    isInviteUser,
    isDemoData,
    isContactUs,
    isUpdates,
    isSettings,
  ]);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "home",
      label: "Home",
      icon: "ri-home-4-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Home");
        history("/dashboard");
      },
    },
    {
      id: "help",
      label: "Help",
      icon: "ri-question-line",
      link: "/help",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Help");
        history("/help");
      },
    },
    {
      id: "invite-user",
      label: "Invite User",
      icon: "ri-user-add-line",
      link: "/invite-user",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("InviteUser");
        history("/invite-user");
      },
    },
    {
      id: "demo-data",
      label: "Demo Data",
      icon: "ri-database-2-line",
      link: "/demo-data",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("DemoData");
        history("/demo-data");
      },
    },
    {
      id: "contact-us",
      label: "Contact Us",
      icon: "ri-customer-service-2-line",
      link: "/contact-us",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("ContactUs");
        history("/contact-us");
      },
    },
    {
      id: "updates",
      label: "Updates",
      icon: "ri-notification-3-line",
      link: "/updates",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Updates");
        history("/updates");
      },
    },
    {
      id: "settings",
      label: "Settings",
      icon: "ri-settings-3-line",
      link: "/settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
        history("/settings");
      },
    },
  ];

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
